module.exports = __webpack_public_path__ + "static/7-0fb7ce97088281d838f3990e7235fda7.jpg";